import { render, staticRenderFns } from "./ProductDetailTop.vue?vue&type=template&id=1741230b&scoped=true&"
import script from "./ProductDetailTop.vue?vue&type=script&lang=js&"
export * from "./ProductDetailTop.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailTop.vue?vue&type=style&index=0&id=1741230b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1741230b",
  null
  
)

export default component.exports